import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bf1257b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-top":"20px"} }
const _hoisted_2 = { style: {"margin-bottom":"50px","margin-top":"-5px","padding-left":"48px"} }
const _hoisted_3 = { class: "billTotal" }
const _hoisted_4 = { style: {"color":"#f56c6c"} }
const _hoisted_5 = { style: {"margin-top":"20px"} }

import { ref, reactive, watch, unref, nextTick, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElTable, ElMessage, ElForm, ElMessageBox } from 'element-plus';
import { useCtCategory } from '@/store/category.store';
import { useDictionary } from '@/store/dictionary.store';
import { PayApplyWriter } from './components/Index';

import { CtCanenceApi, GetDraftEditDataApi, GetPerformListApi, RelContractListApi, CtCancelApi } from '../../apis/contract/contract.api';
import { GetFeeBillsApi, GetFeePayplanListApi } from '../../apis/PayPlans/payplan.api';
import { ContractSearch, ContractDelDto } from '../../apis/contract/contract.type';
import { PerformDetail, PayItems } from '../../apis/PayPlans/payplan.type';

import Reimbursement from './components/reimbursement.vue'
import PayplanDetail from '@/views/contracts/detail/components/payplanDetail.vue'; // 这里引用了合同明细中的付款计划明细对话框
import PayplanBillList from '@/views/contracts/detail/components/billDetail.vue'; // 这里引用了合同明细中的账单明细对话框
import AuditLocusDrawer from './components/BillAuditTimeline.vue';

import moment from 'moment';

import { formatTools } from '@/utils';
import { Dictionary, List } from 'lodash';
import { useLocales } from '@/hooks/useLocales';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { fAmount, fDate } = formatTools();

const { getName } = useDictionary();
const { push } = useRouter();
const isLoading = ref<boolean>(false);
const exportRowKey = ref<string[]>([]);


// 添加多语言支持
const { t } = useLocales();

const planDetailRef = ref<InstanceType<typeof PayplanDetail>>();
const billListRef = ref<InstanceType<typeof PayplanBillList>>();
const payWriterRef = ref<InstanceType<typeof PayApplyWriter>>();
const auditLocusDrawerRef = ref<InstanceType<typeof AuditLocusDrawer>>();
const reimbursementRef = ref<InstanceType<typeof Reimbursement>>();

const tableData = ref<Array<PerformDetail>>([]);
const pageTotal = ref<number>(0);
const reimbursePlans = ref<string[]>([]);
const showAlertDialog = ref<boolean>(false);

/* 查询条件 */
const search = reactive<ContractSearch>({
	page_size: 10,
	current: 1,
});

/* 获取付款计划 */
const getContractData = (searchDto: ContractSearch) => {
	isLoading.value = true;

	GetPerformListApi(searchDto)
		.then((res) => {
			if (!res.succeeded) {
				ElMessage.error(`${t('performs.message.loadDataFailed', '获取履约数据失败，可能的原因：')}${res.errors}`);
			} else {
				const dataList = res.data.data || [];

				pageTotal.value = res.data.total;
				tableData.value = dataList;
			}
		})
		.finally(() => {
			isLoading.value = false;
		});

	GetFeePayplanListApi()
		.then((res) => {
			if (!res.succeeded) {
				ElMessage.error(`${t('performs.message.loadDataFailed', '获取履约数据失败，可能的原因：')}${res.errors}`);
			} else {
				reimbursePlans.value = res.data || [];
			}
		})
		.finally(() => {
			isLoading.value = false;
		});
};

/* 标题行样式 */
const setHeaderRowClass = ({ rowIndex }: { rowIndex: number }) => {
	return 'success-row';
};

/* 刷新列表 */
const refreshList = (ctId: string) => {
	getContractData(search);

	nextTick(() => {
		exportRowKey.value.push(ctId);
	});
};

const canCancel = (row: PerformDetail) =>{
	var count = 0;
	row.payplanList.forEach((payplan: PayItems) => {
		count += payplan.bill_total || 0
	});
	// ElMessage.warning(count.toString())
	return count > 0? false:true;
}


const getRelContract = async (contractId: string) => {
		const res = await RelContractListApi(contractId);
		const { succeeded, errors, data } = res;
		const relinfo = {
			endcontract: '',
			continuecontract:'',
		}
		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			data.forEach((a: any) => {
				if (a.contract_source == "ZZHT") {
					relinfo.endcontract = a.no;
				}
				if (a.contract_source == "LXHT") {
					relinfo.continuecontract = a.no;
				}
			});
			return relinfo
		}
	}



const actions = {
	/* 预览 */
	preview: async (row: any) => {
		await actions.endremind(row.id);
		push({ path: `/contracts/previews`, query: { contractId: `${row.id}` } });
	},
	end: async (row: any) => {
		const enddata: ContractDelDto = { id: row.id, revision: row.revision };
		ElMessageBox.confirm(t('performs.confirm.terminateMessage', '是否终止选中的合同？'), t('performs.confirm.terminateTitle', '提示'), { lockScroll: false, confirmButtonText: t('performs.confirm.confirm', '确定'), cancelButtonText: t('performs.confirm.cancel', '取消'), type: 'warning' }).then(async () => {
			const res = await CtCanenceApi(enddata);
			const {succeeded, errors, data } = res;
			if (!succeeded) {
				ElMessage.error(errors);
			} else
			{
				ElMessage.success(t('performs.message.operationSuccess', '操作成功！'));
				getContractData(search);
			}
		});
	},
	abort: async (row: any) => {
		const abortdata: ContractDelDto = { id: row.id, revision: row.revision };
		ElMessageBox.confirm(t('performs.confirm.voidMessage', '是否废除选中的合同？'), t('performs.confirm.terminateTitle', '提示'), { lockScroll: false, confirmButtonText: t('performs.confirm.confirm', '确定'), cancelButtonText: t('performs.confirm.cancel', '取消'), type: 'warning' }).then(async () => {
			const res = await CtCancelApi(abortdata);
			const {succeeded, errors, data } = res;
			if (!succeeded) {
				ElMessage.error(errors);
			} else
			{
				ElMessage.success(t('performs.message.operationSuccess', '操作成功！'));
				getContractData(search);
			}
		});
	},
	apply: async (row: any) => {
		await actions.endremind(row.contract_id);
		unref(payWriterRef)?.showDialog(row);
	},
	detail: async (row: any) => {
		await actions.endremind(row.contract_id);
		unref(planDetailRef)?.openDialog(row.id);
	},
	bills: async (row: any) => {
		await actions.endremind(row.contract_id);
		unref(billListRef)?.openDialog(row.id);
	},
	locus: async (row: any) => {
		await actions.endremind(row.contract_id);
		unref(auditLocusDrawerRef)?.showDrawer(row.id);
	},
	invoice: async (row: any) => {
		await actions.endremind(row.contract_id);
		unref(reimbursementRef)?.showDialog(row);
	},
	endremind: async (ctId: any) => {
		const relinfo = await getRelContract(ctId);
		if (relinfo && relinfo.endcontract != '')
		{
			ElMessage({
				type: 'warning',
				showClose: true,
				dangerouslyUseHTMLString: true,
				message: `${t('performs.message.contractTerminatedWarning', '警告：该合同已终止，终止合同为：')}${relinfo.endcontract}`,
			})
		}

		if (relinfo && relinfo.continuecontract != '')
		{
			const res = await GetDraftEditDataApi(ctId);
			const data = res.data;
			if (data.contract_limit = 'Y' && fDate(data.end_day) < fDate(new Date()))
			{
				ElMessage({
					type: 'warning',
					showClose: true,
					dangerouslyUseHTMLString: true,
					message: `${t('performs.message.contractExpiredWarning', '警告：该合同已过期，续签合同为：')}${relinfo.continuecontract}`,
				})
			}
		}
	}
};

/* Watch：分页属性改变 */
watch(
	() => search.current,
	() => {
		getContractData(search);
	}
);
watch(
	() => search.page_size,
	() => {
		getContractData(search);
	}
);

onMounted(() => {
	getContractData(search);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_card, {
      shadow: "never",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElForm), {
          size: "small",
          model: _unref(search),
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('performs.form.contractNo', '合同编号'),
              prop: "no"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(search).no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(search).no) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('performs.form.contractName', '合同名称'),
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(search).name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(search).name) = $event)),
                  type: "text"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (getContractData(_unref(search))))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('performs.buttons.query', '查询')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    })), [
      [_directive_loading, isLoading.value]
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(ElTable), {
            size: "small",
            data: tableData.value,
            border: true,
            width: "100%",
            "header-cell-class-name": setHeaderRowClass,
            "row-key": "id",
            "expand-row-keys": exportRowKey.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "expand",
                style: {"text-align":"center"},
                align: 'center'
              }, {
                default: _withCtx((props) => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(ElTable), {
                      size: "small",
                      data: props.row.payplanList,
                      stripe: "",
                      border: true,
                      style: {"width":"100%"},
                      "header-cell-class-name": setHeaderRowClass
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          type: "index",
                          label: _unref(t)('performs.table.sequence', '序号'),
                          width: "60",
                          align: 'center'
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          prop: "name",
                          label: _unref(t)('performs.table.planName', '款项名称'),
                          width: "240",
                          "header-align": "center"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          prop: "pay_condition",
                          label: _unref(t)('performs.table.planCondition', '款项条件'),
                          "show-overflow-tooltip": "",
                          "header-align": "center"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          prop: "scale",
                          label: _unref(t)('performs.table.planScale', '款项比例'),
                          width: "80",
                          "header-align": "center",
                          align: "center"
                        }, {
                          default: _withCtx((dt) => [
                            _createTextVNode(_toDisplayString(dt.row.scale) + "%", 1)
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          prop: "amount",
                          label: _unref(t)('performs.table.amount', '金额'),
                          width: "100",
                          "header-align": "center",
                          align: "right"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createVNode(_component_el_popover, {
                              effect: "light",
                              trigger: "hover",
                              width: "auto"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                  _createTextVNode(_toDisplayString(_unref(t)('performs.table.billCount', '当前付款单数：')), 1),
                                  _createElementVNode("span", null, _toDisplayString(row.bill_total), 1)
                                ]),
                                _createElementVNode("div", null, _toDisplayString(_unref(t)('bill.unpayAmount', '待申请')) + ": " + _toDisplayString(_unref(fAmount)(row.unpay_amt)), 1),
                                _createElementVNode("div", null, _toDisplayString(_unref(t)('bill.auditAmount', '审批中')) + ": " + _toDisplayString(_unref(fAmount)(row.audit_amt)), 1),
                                _createElementVNode("div", null, _toDisplayString(_unref(t)('bill.paidAmount', '已付款')) + ": " + _toDisplayString(_unref(fAmount)(row.isPay_amt)), 1)
                              ]),
                              reference: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(fAmount)(row.amount)), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          prop: "pay_date",
                          label: _unref(t)('performs.table.plannedPayDate', '计划付款日'),
                          width: "100",
                          align: 'center'
                        }, {
                          default: _withCtx((dt) => [
                            _createTextVNode(_toDisplayString(dt.row.pay_date ? _unref(moment)(dt.row.pay_date).format('YYYY-MM-DD') : '--'), 1)
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          prop: "bill_total",
                          label: _unref(t)('performs.table.billCount', '付款单数'),
                          width: "80",
                          align: 'right',
                          "header-align": "center"
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          prop: "is_split",
                          label: _unref(t)('performs.table.payType', '付款类型'),
                          width: "90",
                          align: 'center'
                        }, {
                          default: _withCtx((dt) => [
                            (dt.row.is_split == 0)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 0,
                                  type: "danger",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('bill.paymentPending', '待定')), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (dt.row.is_split == 1)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 1,
                                  type: "primary",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('bill.splitPayment', '分批付款')), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (dt.row.is_split == 2)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 2,
                                  type: "success",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('bill.fullPayment', '全部付款')), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          prop: "status",
                          label: _unref(t)('performs.table.payStatus', '付款状态'),
                          width: "90",
                          align: 'center'
                        }, {
                          default: _withCtx((dt) => [
                            (dt.row.status == 1)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 0,
                                  type: "danger",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('bill.unpaid', '未付款')), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (dt.row.status == 2)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 1,
                                  type: "primary",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('bill.paying', '付款中')), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (dt.row.status == 3)
                              ? (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 2,
                                  type: "success",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('bill.paid', '付款完成')), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          label: _unref(t)('performs.table.action', '操作'),
                          width: "300",
                          align: 'center',
                          flex: "right"
                        }, {
                          default: _withCtx((item) => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              link: "",
                              onClick: ($event: any) => (actions.locus(item.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('performs.buttons.trace', '轨迹')), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              link: "",
                              onClick: ($event: any) => (actions.detail(item.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('performs.buttons.view', '查看')), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            (item.row.can_pay_apply)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "success",
                                  link: "",
                                  onClick: ($event: any) => (actions.apply(item.row))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('performs.buttons.apply', '申请')), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_button, {
                              type: "warning",
                              link: "",
                              onClick: ($event: any) => (actions.bills(item.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('performs.buttons.bills', '付款单')), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            (reimbursePlans.value.indexOf(item.row.id)>=0)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  type: "warning",
                                  link: "",
                                  onClick: ($event: any) => (actions.invoice(item.row))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('performs.buttons.reimbursement', '费用报销')), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 2
                    }, 1032, ["data"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: _unref(t)('performs.table.contractName', '合同名称'),
                "show-overflow-tooltip": "",
                width: "140",
                "header-align": "center"
              }, {
                default: _withCtx((props) => [
                  _createElementVNode("span", null, _toDisplayString(props.row.name), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "plan_a_name",
                label: _unref(t)('performs.table.ourParty', '我方主体'),
                "show-overflow-tooltip": "",
                "header-align": "center"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "counterpart_name",
                label: _unref(t)('performs.table.counterpart', '相对方'),
                "show-overflow-tooltip": "",
                "header-align": "center"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "contract_type",
                label: _unref(t)('performs.table.contractCategory', '合同分类'),
                "show-overflow-tooltip": "",
                width: "240",
                "header-align": "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", null, _toDisplayString(_unref(useCtCategory)().getName(row.category_id)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                sortable: "",
                prop: "created_time",
                label: _unref(t)('performs.table.contractSubmitTime', '合同提交时间'),
                "show-overflow-tooltip": "",
                width: "160",
                "header-align": "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.created_time), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "payment",
                label: _unref(t)('performs.table.paymentMethod', '付款方式'),
                width: "80",
                align: 'center'
              }, {
                default: _withCtx((props) => [
                  _createTextVNode(_toDisplayString(_unref(getName)('contract_payment', props.row.payment)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "contract_amount",
                label: _unref(t)('performs.table.contractAmount', '合同金额'),
                width: "100",
                align: "right",
                "header-align": "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_unref(fAmount)(row.contract_amount)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "pay_amount",
                label: _unref(t)('performs.table.paidAmount', '已付金额'),
                width: "100",
                align: "right",
                "header-align": "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_unref(fAmount)(row.pay_amount)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "unpay_amount",
                label: _unref(t)('performs.table.unpaidAmount', '未付金额'),
                width: "100",
                align: "right",
                "header-align": "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(fAmount)(row.unpay_amount)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "audit_amount",
                label: _unref(t)('performs.table.auditAmount', '审批金额'),
                width: "100",
                align: "center",
                "header-align": "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_unref(fAmount)(row.audit_amount)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: _unref(t)('performs.table.action', '操作'),
                width: "180",
                align: 'center',
                flex: "right"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    link: "",
                    onClick: ($event: any) => (actions.preview(row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('performs.buttons.detail', '详细')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (!canCancel(row))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "danger",
                        link: "",
                        onClick: ($event: any) => (actions.end(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('performs.buttons.terminate', '终止')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (canCancel(row))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "danger",
                        link: "",
                        onClick: ($event: any) => (actions.abort(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('performs.buttons.void', '作废')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["data", "expand-row-keys"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_pagination, {
            small: "",
            background: "",
            pageSize: _unref(search).page_size,
            "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((_unref(search).page_size) = $event)),
            currentPage: _unref(search).current,
            "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_unref(search).current) = $event)),
            hideOnSinglePage: false,
            layout: 'sizes, prev, pager, next, jumper, ->, total',
            pageSizes: [10, 20, 30, 40, 50, 100],
            pagerCount: 8,
            total: pageTotal.value
          }, null, 8, ["pageSize", "currentPage", "total"])
        ])
      ]),
      _: 1
    })), [
      [_directive_loading, isLoading.value]
    ]),
    _createVNode(_unref(PayApplyWriter), {
      ref_key: "payWriterRef",
      ref: payWriterRef,
      onRefresh: refreshList
    }, null, 512),
    _createVNode(PayplanDetail, {
      ref_key: "planDetailRef",
      ref: planDetailRef
    }, null, 512),
    _createVNode(PayplanBillList, {
      ref_key: "billListRef",
      ref: billListRef
    }, null, 512),
    _createVNode(AuditLocusDrawer, {
      ref_key: "auditLocusDrawerRef",
      ref: auditLocusDrawerRef
    }, null, 512),
    _createVNode(Reimbursement, {
      ref_key: "reimbursementRef",
      ref: reimbursementRef
    }, null, 512)
  ], 64))
}
}

})